var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    fillRule: "nonzero",
    d: "M12 4c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.419 0 8-3.582 8-8s-3.582-8-8-8z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.037 3.725v-1.04C7.037 1.205 5.707 0 4.074 0 2.44 0 1.111 1.205 1.111 2.685v1.04C.481 3.833 0 4.382 0 5.043V8.66C0 9.4.6 10 1.339 10h5.47c.739 0 1.34-.6 1.34-1.339V5.042c0-.66-.482-1.209-1.112-1.317zm-5.556-1.04C1.481 1.41 2.644.37 4.074.37S6.667 1.41 6.667 2.685v1.019H1.48V2.685zm6.297 5.976c0 .534-.435.969-.969.969H1.34C.805 9.63.37 9.195.37 8.66V5.042c0-.533.435-.968.969-.968h5.47c.534 0 .969.435.969.968v3.62z",
    transform: "translate(8 7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.074 5.185c-.408 0-.74.332-.74.74v1.112c0 .409.332.74.74.74.409 0 .74-.331.74-.74V5.926c0-.409-.331-.74-.74-.74zm.37 1.852c0 .204-.166.37-.37.37s-.37-.166-.37-.37V5.926c0-.204.166-.37.37-.37s.37.166.37.37v1.111z",
    transform: "translate(8 7)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M8 7.86H12V10.56H8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessUnlocked);
export default __webpack_public_path__ + "static/media/access_unlocked.d495474918c78514ae3bd7fc81c1e7c9.svg";
export { ForwardRef as ReactComponent };